import type { FixedProductVariantInput } from '@weft/types';
import { PAYMENT_TERMS, FIXED_PRODUCT_TYPES } from '@weft/types';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useChargeContext } from '../../../charge-context';
import type { NewPlanForm } from '../../../CreatePlanForm/create-plan-form-types/new-plan-form';
import type { PlanInputForm } from '../../../CreatePlanForm/create-plan-form-types/plan-input-form';
import { ChargeEditDrawerProductSettings } from '../ChargeEditDrawerProductSettings';
import { PaymentTermDropdown } from './PaymentTermDropdown';
import { SeparateInvoiceSwitch } from './SeparateInvoiceSwitch';

export const AsCreditSelector: React.FC = () => {
  const { itemIndex: productIndex } = useChargeContext();
  const { control, setValue, watch } = useFormContext<PlanInputForm, NewPlanForm>();

  const settingsProductTypeWatch = watch(`fixedProducts.${productIndex}.variants.0.settings.productType`);

  const handleCreditChecked = (checked: boolean) => {
    if (checked) {
      setValue(`fixedProducts.${productIndex}.variants.0.settings`, getDefaultCreditProductSettings());
      setValue(`fixedProducts.${productIndex}.paymentTerm`, PAYMENT_TERMS.Prepayment);
    } else {
      setValue(`fixedProducts.${productIndex}.variants.0.settings`, undefined);
      setValue(`fixedProducts.${productIndex}.paymentTerm`, PAYMENT_TERMS.Postpayment);
    }
  };

  return (
    <div className="flex flex-col gap-y-6">
      <ChargeEditDrawerProductSettings
        isChecked={settingsProductTypeWatch == FIXED_PRODUCT_TYPES.Credit}
        label='Credit purchase'
        handleOnChecked={handleCreditChecked}
      >
        <div className="flex items-center gap-x-2">
          <SeparateInvoiceSwitch
            fieldPath={`fixedProducts.${productIndex}.variants.0.settings.productConfiguration.shouldCreateSeparateInvoice`}
            control={control}
          />
        </div>

        <div className="flex items-center gap-x-2 pt-4">
          <PaymentTermDropdown
            productIndex={productIndex}
            control={control}
            defaultPaymentTerm={PAYMENT_TERMS.Prepayment}
          />
        </div>
      </ChargeEditDrawerProductSettings>
    </div>
  );
};

export const getDefaultCreditProductSettings = (): FixedProductVariantInput['settings'] => ({
  productType: FIXED_PRODUCT_TYPES.Credit,
  productConfiguration: {
    shouldCreateSeparateInvoice: false,
  },
});